import apis from './config';

const pageApi = apis.page;

// Includes hidden pages: the backoffice list is where you un-hide one.
export const fetchPages = async () => {
    try {
        const response = await pageApi.get('/?includeInvisible=true', {
            headers: { Accept: 'application/json' },
        });
        return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
        console.error('Error fetching pages:', error);
        throw error;
    }
};

// Template names available to the pickers, grouped by slot folder:
// { pages: [...], cards: [...], articles: [...] } — read from src/templates/ on disk.
export const fetchTemplates = async () => {
    try {
        const response = await pageApi.get('/templates', {
            headers: { Accept: 'application/json' },
        });
        const data = response.data || {};
        return { pages: data.pages || [], cards: data.cards || [], articles: data.articles || [] };
    } catch (error) {
        console.error('Error fetching templates:', error);
        throw error;
    }
};

// Accepts any subset of { headTitle, headDescription, headerTitle, navLabel,
// template, cardTemplate, articleTemplate, isVisible }. The server re-renders
// the affected HTML before responding.
export const updatePage = async (id, pageData) => {
    try {
        const response = await pageApi.patch(`/${id}`, pageData, {
            retag: true,
            validateCsrf: true,
        });
        return response.data;
    } catch (error) {
        console.error('Error updating page:', error);
        throw error;
    }
};
